export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.1-1044.55",
  commitId: "aa50c8949e156bf8b94d3bdc659562e84e55fbf2",
  commitTime: "2026-06-01T10:44:55.000Z",
});
